import { shallowEqual } from 'react-redux';

import { Card } from '@zillow/constellation';
import { LoadingText } from '@zg-rentals/loading-components';

import { useSelector } from '../../../../selectors/useSelector';

import { StyledSpacer } from '../../StyledComponents';

const EmptyLeasesCardSimple = ({ isLoading = false }: { isLoading?: boolean }) => {
  const { isLeaseBuilderRestricted } = useSelector((state) => {
    return {
      isLeaseBuilderRestricted: state.properties.currentProperty.restrictions.isLeaseBuilderRestricted,
    };
  }, shallowEqual);

  const bodyContent = isLeaseBuilderRestricted ? 'Upload a lease' : 'Upload or create a lease';
  return (
    <Card data-testid="EmptyLeasesCardSimple" cardType="secondary" cardElevation={0}>
      <LoadingText textStyle="body-bold" loadingWidth="100%" isLoading={isLoading}>
        Active leases will appear here
      </LoadingText>

      <StyledSpacer>
        <LoadingText textStyle="body-sm" loadingWidth="75%" isLoading={isLoading}>
          {bodyContent}
        </LoadingText>
      </StyledSpacer>
    </Card>
  );
};

export default EmptyLeasesCardSimple;
